import v2020 from '@/sui/data/sheets/edit/observa4/2020'
import v2021 from '@/sui/data/sheets/edit/observa4/2021'
import v2022 from '@/sui/data/sheets/edit/observa4/2022'
import v2023 from '@/sui/data/sheets/edit/observa4/2023'
import v2024 from '@/sui/data/sheets/edit/observa4/2024'
import v2025 from '@/sui/data/sheets/edit/observa4/2025'
import v2026 from '@/sui/data/sheets/edit/observa4/2026'

const result = {
  '2020': v2020.sheet,
  '2021': v2021.sheet,
  '2022': v2022.sheet,
  '2023': v2023.sheet,
  '2024': v2024.sheet,
  '2025': v2025.sheet,
  '2026': v2026.sheet
}

export default result
